/*
  bf-lazy-video.js
  Load in layout/theme.liquid with:
    <script src="{{ 'bf-lazy-video.js' | asset_url }}" defer="defer"></script>

  - Loads + plays <video class="bf-lazy-video"> only when it's ~300px from the viewport
  - Pauses it again when it scrolls out of view
  - data-src, or data-src-desktop / data-src-mobile (switch at 750px)
  - data-poster: poster is set only when the video is near the viewport
  - Save-Data, 2G and reduced-motion visitors get the poster only (no video bytes)
  - Re-scans a section when it re-renders in the theme editor
*/
(function () {
  'use strict';

  var SELECTOR = 'video.bf-lazy-video';
  var ROOT_MARGIN = '300px 0px'; // start loading ~300px before it scrolls in

  var conn = navigator.connection || {};
  var thinPipe = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
  var stillPlease = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var posterOnly = thinPipe || stillPlease;
  var wide = window.matchMedia('(min-width: 750px)');
  var io = null;

  function sourceFor(v) {
    if (v.dataset.src) return v.dataset.src;
    return wide.matches ? v.dataset.srcDesktop : v.dataset.srcMobile;
  }

  function showPoster(v) {
    if (v.dataset.poster && !v.getAttribute('poster')) {
      v.setAttribute('poster', v.dataset.poster);
    }
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var v = entry.target;

      if (!entry.isIntersecting) {
        if (v.dataset.bfLoaded) v.pause();
        return;
      }

      showPoster(v);

      if (posterOnly) {
        io.unobserve(v);
        return;
      }

      if (!v.dataset.bfLoaded) {
        var src = sourceFor(v);
        if (!src) return;
        v.src = src;
        v.dataset.bfLoaded = '1';
        v.load();
      }

      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked: poster stays */ });
    });
  }

  function observeWithin(root) {
    var vids = (root || document).querySelectorAll(SELECTOR);
    if (!vids.length) return;

    // Very old browser: show posters, load no video.
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, showPoster);
      return;
    }

    if (!io) {
      io = new IntersectionObserver(onIntersect, { rootMargin: ROOT_MARGIN, threshold: 0.01 });
    }

    Array.prototype.forEach.call(vids, function (v) {
      if (v.dataset.bfObserved) return;
      v.dataset.bfObserved = '1';
      v.muted = true;          // required for muted autoplay on iOS
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      io.observe(v);
    });
  }

  function init() {
    observeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor: when a section re-renders, pick up its new <video> elements.
  document.addEventListener('shopify:section:load', function (e) {
    observeWithin(e.target);
  });
})();